/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const ApplicationForm = () => {
  const theme = useTheme();

  return (
    <Box id="postulacion" mt={8}>
      <Typography
        variant="h5"
        component="h2"
        align="center"
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        Formulario de postulación
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}
      >
        En lugar de "comprar", aplicas para formar parte de una conversación
        diseñada para posicionar tu liderazgo. Cuéntanos por qué tu historia
        debería ser parte de TNO Business.
      </Typography>

      <Box
        component={Card}
        maxWidth={{ xs: '100%', md: '60%' }}
        boxShadow={4}
        margin="0 auto"
      >
        <CardContent>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
              '& .MuiInputBase-input.MuiOutlinedInput-input': {
                bgcolor: 'background.paper',
              },
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Nombre y Cargo"
                  variant="outlined"
                  color="primary"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Empresa / Organización"
                  variant="outlined"
                  color="primary"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Tema o Hito que deseas compartir (Lanzamiento, Aniversario, Innovación, etc.)"
                  variant="outlined"
                  color="primary"
                  fullWidth
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Enlace a LinkedIn"
                  variant="outlined"
                  color="primary"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Sitio web corporativo (opcional)"
                  variant="outlined"
                  color="primary"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Mensaje adicional para el equipo editorial (opcional)"
                  variant="outlined"
                  color="primary"
                  fullWidth
                  multiline
                  rows={3}
                />
              </Grid>
              <Grid item xs={12}>
                <Box textAlign="center" mt={1}>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ mb: 2 }}
                  >
                    Nuestro equipo editorial evaluará tu perfil para asegurar
                    que tu mensaje conecte con los valores de excelencia de
                    TNO Business.
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    sx={{ minWidth: 220 }}
                  >
                    Enviar postulación
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Box>

      <Box
        mt={4}
        px={2}
        py={2}
        sx={{
          maxWidth: 720,
          mx: 'auto',
          borderRadius: 2,
          bgcolor:
            theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
        }}
      >
        <Typography
          variant="subtitle2"
          color="textSecondary"
          align="center"
        >
          TNO Business no es publicidad tradicional. Es un espacio curado donde
          tu historia se convierte en punto de referencia para otros líderes.
        </Typography>
      </Box>
    </Box>
  );
};

export default ApplicationForm;

